import React, { useState } from 'react';
import './SettingsPage.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useAuth } from '../../AuthContext';
import { Link } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';

const SettingsPage = () => {
    const { user } = useAuth();
    const userDetails = user.user;

    const [formData, setFormData] = useState({

        username: userDetails.username || '',
        mobile: userDetails.mobile || '',
        email: userDetails.email || '',
        role: userDetails.role || '',
        address: userDetails.address || '',
        date_of_birth: userDetails.date_of_birth || '',
        blood_group: userDetails.blood_group || '',
        id_proof: userDetails.id_proof || '',
        id_proof_number: userDetails.id_proof_number || '',
        work_type: userDetails.work_type || '',
        previous_work: userDetails.previous_work || '',
        previous_work_with: userDetails.previous_work_with || '',
        reference_name: userDetails.reference_name || '',
        password: userDetails.password || '',
        confirm_password: userDetails.confirm_password || '',
        total_task_count: userDetails.total_task_count || '',
        total_distance_count: userDetails.total_distance_count || '',
        total_present_days_count: userDetails.total_present_days_count || '',
        total_absent_days_count: userDetails.total_absent_days_count || '',
        uuId: userDetails.uuId || '',
        manager: userDetails.manager || '',
        punch_In: userDetails.punch_In || '',
        punch_out: userDetails.punch_out || '',
        total_hour: userDetails.total_hour || '',
        profile: userDetails.profile || '',
        date_of_join: userDetails.date_of_join || '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const updateTask = async () => {
        try {
          const response = await axios.put(API_URL + `/user/${userDetails.username}`, formData);
    
          if (response.status === 200) {
            console.log('User updated successfully');
            window.alert('User updated successfully!')
            sessionStorage.removeItem('user');
        window.location.reload(true);
        window.location.href = '/SignIn'
          } else {
            console.error('Error updating user');
          }
        } catch (error) {
          console.error(error);
        }
      };

    return (
        <div>
            <SideMenuBar></SideMenuBar>
            <div class="content">
                <NewHeader></NewHeader>

                <div className='row2'>
                    <h3 className='settings_SettingsPage'>Settings</h3>
                </div>

                <div className='row3_SettingsPage'>
                    <div className='heading_SettingsPage'>
                        <Link to='/SettingsPage' className='a_of_heading'><p className='profile_SettingsPage'>&nbsp;Profile&nbsp;</p></Link>
                        <Link to='/SettingPswd' className='a_of_heading'><p className='password_SettingsPage'>&nbsp;Password&nbsp;</p></Link>
                        <Link to='/SettingReport' className='a_of_heading'><p className='report_SettingsPage'>&nbsp;Report&nbsp;</p></Link>
                    </div>
                    <div className='subrow1_row3_SettingsPage'>
                        <p className='your_profile_pic'>Your Profile Picture</p>
                        <a href='/'><img className='uploadPhoto_icon' src='../assets/gallery.png' alt='upload-icon'></img></a>
                    </div><hr className='hr_of_SettingsPage' />

                    <div class="subrow2_row3_SettingsPage">
                        <div class="column1_subrow2_row3_SettingsPage">
                            <p>Full Name</p>
                            <input className='input_subrow2_row3_SettingsPage' placeholder='Enter Full Name' name='username'
                                value={formData.username}
                                readOnly disabled></input>
                            <p>Username</p>
                            <input className='input_subrow2_row3_SettingsPage' placeholder='Enter Username' name='username'
                                value={formData.username}
                                readOnly disabled></input>
                        </div>

                        <div class="column2_subrow2_row3_SettingsPage">
                            <p>Email ID</p>
                            <input className='input_subrow2_row3_SettingsPage' placeholder='Enter Email ID' name='email'
                                value={formData.email}
                                onChange={handleInputChange}></input>
                            <p>Phone No.</p>
                            <input className='input_subrow2_row3_SettingsPage' placeholder='Enter Phone No.' name='mobile'
                                value={formData.mobile}
                                onChange={handleInputChange}></input><br /><br /><br />
                            <button className='update_btn_SettingsPage' onClick={updateTask}>Update</button>
                        </div>
                    </div>
                </div>




            </div>
        </div>
    )
}

export default SettingsPage;